<script>
	import { onMount } from "svelte";

	import { navigate } from "svelte-routing";
	import { Button, Col, Row } from "sveltestrap";
	import FilterForm from "../../../components/FilterForm/FilterForm.svelte";
	import PageHeader from "../../../components/PageHeader/PageHeader.svelte";
	import SizeSelect from "../../../components/SizeSelect/SizeSelect.svelte";
	import client from "../../../services/client";
	import GroupTable from "./GroupTable.svelte";
	import queryString from "query-string";
	import { loading, totalPages, sizeSelect } from "../../../store/store";
	import { listQueryParams } from "../../../services/helpers";
	import { extractErrorMessage } from "../../../utils/misc";

	const query = queryString.parse(window.location.search);
	let data = [];

	if (query.status == "0") {
		query.status = true;
	} else if (query.status == "1") {
		query.status = false;
	}
	onMount(async () => {
		loading.set(true);
		try {
			const res = await client("/v0/Group/GetWithFilters", {
				method: "POST",
				version: "Tasking",
				data: { ...listQueryParams(query) },
			});
			data = res.data.data.groups;
			totalPages.set(res.data.data.totalPages);
			loading.set(false);
		} catch (err) {
			extractErrorMessage(err);
			loading.set(false);
		}
	});

	const trigerSelectGroup = async (size) => {
		try {
			loading.set(true);
			const res = await client("/v0/Group/GetWithFilters", {
				method: "POST",
				version: "Tasking",
				data: { ...listQueryParams(query), limit: size },
			});
			data = res.data.data.groups;
			totalPages.set(res.data.data.totalPages);
			loading.set(false);
		} catch (err) {
			extractErrorMessage(err);
			loading.set(false);
		}
	};

	$: $sizeSelect, trigerSelectGroup($sizeSelect);

	const handleInactive = async (id, status) => {
		loading.set(true);
		try {
			if (status == true) {
				status = false;
			} else {
				status = true;
			}
			const res = await client("/v0/Group/Update", {
				method: "POST",
				version: "Tasking",
				data: {
					group: id,
					status,
				},
			});
			if (res.status === 200) {
				trigerSelectGroup();
			}
		} catch (error) {
			console.log(error);
			loading.set(false);
		}
	};
</script>

<Row>
	<Col xs={12}>
		<div>
			<Col className="row d-flex align-items-start mx-0">
				<PageHeader title="Group" />
			</Col>
			<div class="d-flex flex-row">
				<Col xs={6}>
					<FilterForm statusName alignItem={"deleted_page"} />
				</Col>
				<Col class="d-flex justify-content-end" xs={6}>
					<!-- <div class="mx-2">
						<Button class="themeButton primary px-4" block
							>Import CSV</Button
						>
						<a href="" class="link ">
							<span class="link-text mt-2">
								Download CSV Template
							</span>
						</a>
					</div>
					<div class="mx-2">
						<Button class="themeButton primary px-4">EXPORT</Button>
					</div> -->
					<div class="mx-2">
						<Button
							class="themeButton primary px-4"
							on:click={() => navigate("group/create-group")}
							>Create Group</Button
						>
						<div class="my-2">
							<SizeSelect {trigerSelectGroup} />
						</div>
					</div>
				</Col>
			</div>
			<div />
		</div>
	</Col>
	<Col class="my-2">
		<GroupTable {data} {handleInactive} />
	</Col>
</Row>
